import { api, basePath } from '../core/config';
import { get } from '../core/api';

export const getParentInvoices = async (opts = {}) => get(
  api,
  basePath.getParentInvoices,
  opts,
);

export default {
  getParentInvoices,
};
